export const PENDING = "PENDING";
export const REQUEST = "REQUEST";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const RESET = "RESET";
export const SET = "SET";
export const UNSET = "UNSET";
export const UPDATE_ITEMS = "UPDATE_ITEMS";
export const RESET_ITEMS = "RESET_ITEMS";
export const UPDATE_SECTIONS = "UPDATE_SECTIONS";
export const UPDATE_SECTIONS_PROPERTY = "UPDATE_SECTIONS_PROPERTY";
export const UPDATE_PROPERTY = "UPDATE_PROPERTY";

export const createRequestTypes = (base) =>
  [RESET, REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});

export const createFlagTypes = (base) =>
  [
    SET,
    UNSET,
    UPDATE_ITEMS,
    RESET_ITEMS,
    UPDATE_SECTIONS,
    UPDATE_PROPERTY,
    FAILURE,
    UPDATE_SECTIONS_PROPERTY,
  ].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});

export const VIEWS = createFlagTypes("VIEWS");
export const ACTIVE_VIEW_IDX = createFlagTypes("ACTIVE_VIEW_IDX");
export const INTERESTS = createFlagTypes("INTERESTS");
export const STORY = createFlagTypes("STORY");
export const SHOW_INTRO = createFlagTypes("SHOW_INTRO");
